import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { API_BASE_URL } from "../config";
import "../styles/Login.css";

const ResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);

  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");

  const handleSubmit = async () => {
    if (!password || !confirmPassword) {
      setMessage("Todos los campos son obligatorios");
      setIsError(true);
      return;
    }

    if (password.length < 6) {
      setMessage("La contraseña debe tener al menos 6 caracteres");
      setIsError(true);
      return;
    }

    if (password !== confirmPassword) {
      setMessage("Las contraseñas no coinciden");
      setIsError(true);
      return;
    }

    console.log("🔐 Token de URL:", token);

    try {
      const response = await fetch(`${API_BASE_URL}/auth/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, new_password: password }),
      });     

      const data = await response.json();

      console.log("Response:", data);

      if (response.ok) {
        setMessage("Contraseña actualizada correctamente");
        setIsError(false);
        setTimeout(() => navigate("/login"), 1500);
      } else {
        setMessage(data.message || "Error al cambiar contraseña");
        setIsError(true);
      }
    } catch (error) {
      console.error(error);
      setMessage("Error al conectar con el servidor");
      setIsError(true);
    }
  };

  return (
    <div className="form-container">
      <h2 className="form-title">Restablecer Contraseña</h2>
      <input
        type="password"
        placeholder="Nueva contraseña"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        className="form-input"
      />
      <input
        type="password"
        placeholder="Confirmar contraseña"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        className="form-input"
      />
      <button onClick={handleSubmit} className="form-button">
        Guardar nueva contraseña
      </button>

      {message && (
        <div className={`toast toast-${isError ? "error" : "success"} show`}>
          {message}
        </div>
      )}
    </div>
  );
};

export default ResetPassword;
